/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 05.11.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";

/**
 * Bootstrap tabs component. Use like this:
 *
 * <Tabs selected="name1" onSelectTab={callbackWhenTabIsSelected}>
 *     <div id="name1" title="My tab 1 title">My tab 1 content</div>
 *     <div id="name2" title="My tab 2 title" >My tab 2 content</div>
 *     ...
 * </Tabs>
 *
 * You can implement all tab contents at once (component will automatically display the right one) or only one based by what tab is currently active (use onSelectTab to detect this).
 */
class Tabs extends React.Component {
    static propTypes = {
        selected: PropTypes.string,
        /**
         * onSelectTab(tabId)
         */
        onSelectTab: PropTypes.func
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            selected: props.selected
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({selected: nextProps.selected});
    }

    render() {
        return (
            <div>
                <ul className="nav nav-tabs" role="tablist">
                    {this.renderTabTitles()}
                    <div className="tab-content">
                        {this.renderChildren()}
                    </div>
                </ul>
            </div>
        );
    }

    renderTabTitles() {
        return (
            <ul className="nav nav-tabs">
                {
                    React.Children.map(this.props.children,
                        (child) => {
                            if (!React.isValidElement(child)) return null;
                            let id = child.props.id;
                            let title = (child.props.title ? child.props.title : id);
                            return (<li key={id} className={(id === this.state.selected ? "active" : "")}><a onClick={() => {this.onSelectTab(id)}} >{title}</a></li>);
                        })
                }
            </ul>
        );
    }

    renderChildren() {
        return React.Children.map(this.props.children,
            (child) => {
                if (!React.isValidElement(child)) return child;
                // We will render only selected child!
                if (child.props.id !== this.state.selected) return null;

                let newProps = {
                    role: "tabpanel",
                    key: child.props.id,
                    className: child.props.className
                };
                if (!newProps.className) newProps.className = "tab-pane";
                else if (newProps.className.indexOf("tab-pane") == -1) newProps.className += "tab-pane";
                newProps.className = newProps.className.replace(/ *\bactive\b */, " ");
                // if (childProps.id === this.state.selected) childProps.className += " active";
                newProps.className += " active";

                return React.cloneElement(child, newProps);
            }
        );
    }

    onSelectTab(name) {
        if (this.props.onSelectTab) this.props.onSelectTab(name);
        else {
            this.setState({selected: name});
        }
    }
}

export default Tabs;
